<app-app-holder>
    <app-navbar></app-navbar>

    <app-sidebar>
        <div class="sidebar-spacing">
            <h3>Fleet</h3>
            <small>Bedrijfswagens</small>
        </div>
    </app-sidebar>

    <app-content>
        <div class="app__title">
            <h1>
                Fleet overzicht
                <span>({{ vehicles.length }} totaal, {{ activeVehiclesCount }} actief)</span>
            </h1>
        </div>

        <div class="card m-b-4">
            <h3>CSV upload</h3>
            <p class="m-b-2">Upload maandelijks het nieuwste SD Worx fleet-exportbestand.</p>
            <div class="d-flex align-items-center gap-2">
                <input
                    type="file"
                    accept=".csv,.CSV,text/csv"
                    (change)="onFileSelected($event)" />
                <button
                    class="button button--primary"
                    [ngClass]="{ 'button--loading': uploading }"
                    (click)="uploadCsv()">
                    Upload CSV
                </button>
            </div>

            <div
                class="m-t-2"
                *ngIf="importResult">
                <small>
                    Verwerkt: {{ importResult.processedRows }} | Overgeslagen: {{ importResult.skippedRows }} | Nieuwe wagens:
                    {{ importResult.createdVehicles }} | Gewijzigde wagens: {{ importResult.updatedVehicles }} | Nieuwe historiek:
                    {{ importResult.createdHistoryRows }} | Gewijzigde historiek: {{ importResult.updatedHistoryRows }} | Niet gekoppelde
                    werknemers: {{ importResult.unresolvedEmployeeLinks }}
                </small>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group m-b-2">
                    <label>Zoeken</label>
                    <input
                        type="text"
                        [(ngModel)]="filter"
                        (ngModelChange)="onFilterChanged()"
                        placeholder="Nummerplaat, model of bestuurder" />
                </div>

                <div class="form-group m-b-2">
                    <label class="d-flex align-items-center gap-2">
                        <input
                            type="checkbox"
                            [(ngModel)]="showActiveOnly"
                            (ngModelChange)="onFilterChanged()" />
                        <span title="Actief = fleet gestart en niet beëindigd (op basis van fleet start- en einddatum).">Enkel actieve wagens (datum-gebaseerd)</span>
                    </label>
                </div>

                <div class="table-scroll">
                <table class="table-view">
                    <tr>
                        <th><button class="sort-button" (click)="toggleOverviewSort('licensePlate')">Nummerplaat {{ getOverviewSortIndicator('licensePlate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('vehicleModel')">Model {{ getOverviewSortIndicator('vehicleModel') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('estimatedFuelType')">Brandstof (geschat) {{ getOverviewSortIndicator('estimatedFuelType') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('fuelType')">Brandstof {{ getOverviewSortIndicator('fuelType') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('co2Emission')">CO2 {{ getOverviewSortIndicator('co2Emission') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('assignedEmployeeName')">Bestuurder {{ getOverviewSortIndicator('assignedEmployeeName') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('currentAssignmentStartDate')">Toewijzing start {{ getOverviewSortIndicator('currentAssignmentStartDate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('currentAssignmentEndDate')">Toewijzing einde {{ getOverviewSortIndicator('currentAssignmentEndDate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('lastImportedAt')">Importdatum {{ getOverviewSortIndicator('lastImportedAt') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('fleetStartDate')">Fleet start {{ getOverviewSortIndicator('fleetStartDate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('fleetEndDate')">Fleet einde {{ getOverviewSortIndicator('fleetEndDate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('catalogValue')">Catalogus {{ getOverviewSortIndicator('catalogValue') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('firstRegistrationDate')">1e inschr. {{ getOverviewSortIndicator('firstRegistrationDate') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('hybridType')">Hybride type {{ getOverviewSortIndicator('hybridType') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('hybridEnergyCapacity')">Hybride energie {{ getOverviewSortIndicator('hybridEnergyCapacity') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('historyCount')">Historiek {{ getOverviewSortIndicator('historyCount') }}</button></th>
                        <th><button class="sort-button" (click)="toggleOverviewSort('notes')">Notities {{ getOverviewSortIndicator('notes') }}</button></th>
                    </tr>
                    <tr
                        *ngFor="let vehicle of filteredVehicles"
                        (click)="selectVehicle(vehicle)"
                        class="pointer"
                        [class.active-row]="selectedVehicle?.uuid === vehicle.uuid">
                        <td>{{ vehicle.licensePlate }}</td>
                        <td>{{ vehicle.vehicleModel || '-' }}</td>
                        <td>{{ vehicle.estimatedFuelType || '-' }}</td>
                        <td>{{ vehicle.fuelType || '-' }}</td>
                        <td>{{ vehicle.co2Emission ?? '-' }}</td>
                        <td>
                            {{ vehicle.assignedEmployeeName || '-' }}
                            <span *ngIf="vehicle.driverOverridden" class="badge badge--small badge--info" title="Handmatig overschreven">✎</span>
                        </td>
                        <td>{{ vehicle.currentAssignmentStartDate ? (vehicle.currentAssignmentStartDate | date) : '-' }}</td>
                        <td>{{ vehicle.currentAssignmentEndDate ? (vehicle.currentAssignmentEndDate | date) : '-' }}</td>
                        <td>{{ vehicle.lastImportedAt ? (vehicle.lastImportedAt | date: 'dd/MM/yyyy HH:mm') : '-' }}</td>
                        <td>{{ vehicle.fleetStartDate ? (vehicle.fleetStartDate | date) : '-' }}</td>
                        <td>{{ vehicle.fleetEndDate ? (vehicle.fleetEndDate | date) : '-' }}</td>
                        <td>{{ vehicle.catalogValue | currency: 'EUR' }}</td>
                        <td>{{ vehicle.firstRegistrationDate ? (vehicle.firstRegistrationDate | date) : '-' }}</td>
                        <td>{{ vehicle.hybridType || '-' }}</td>
                        <td>{{ vehicle.hybridEnergyCapacity || '-' }}</td>
                        <td>{{ vehicle.historyCount }}</td>
                        <td>{{ vehicle.notes || '-' }}</td>
                    </tr>
                    <tr *ngIf="!loadingVehicles && filteredVehicles.length === 0">
                        <td colspan="17">Geen voertuigen gevonden.</td>
                    </tr>
                </table>
                </div>
            </div>
        </div>

        <ng-template #vehicleDetailModal let-modal>
            <div class="modal-wrapper" *ngIf="selectedVehicle">
                <div class="modal-header">
                    <h4 class="modal-title">{{ selectedVehicle?.licensePlate }} - {{ selectedVehicle?.vehicleModel }}</h4>
                    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <nav
                    #nav="ngbNav"
                    [(activeId)]="activeTab"
                    class="tabs__modal"
                    ngbNav>
                    <ng-container [ngbNavItem]="'information'">
                        <a ngbNavLink>Informatie</a>
                        <ng-template ngbNavContent>
                            <ul class="list__specs fleet-specs m-b-3">
                                <li><label>Nummerplaat</label><span>{{ selectedVehicle.licensePlate || '-' }}</span></li>
                                <li><label>Model</label><span>{{ selectedVehicle.vehicleModel || '-' }}</span></li>
                                <li><label>Brandstof (geschat)</label><span>{{ selectedVehicle.estimatedFuelType || '-' }}</span></li>
                                <li><label>Brandstof</label><span>{{ selectedVehicle.fuelType || '-' }}</span></li>
                                <li><label>CO2</label><span>{{ selectedVehicle.co2Emission ?? '-' }}</span></li>
                                <li>
                                    <label>Bestuurder</label>
                                    <span>
                                        {{ selectedVehicle.assignedEmployeeName || '-' }}
                                        <span *ngIf="selectedVehicle.driverOverridden" class="badge badge--small badge--info" title="Handmatig overschreven">✎ overschreven</span>
                                    </span>
                                </li>
                                <li><label>Toewijzing start</label><span>{{ selectedVehicle.currentAssignmentStartDate ? (selectedVehicle.currentAssignmentStartDate | date) : '-' }}</span></li>
                                <li><label>Toewijzing einde</label><span>{{ selectedVehicle.currentAssignmentEndDate ? (selectedVehicle.currentAssignmentEndDate | date) : '-' }}</span></li>
                                <li><label>Laatst geïmporteerd</label><span>{{ selectedVehicle.lastImportedAt ? (selectedVehicle.lastImportedAt | date: 'dd/MM/yyyy HH:mm') : '-' }}</span></li>
                                <li><label>Fleet start</label><span>{{ selectedVehicle.fleetStartDate ? (selectedVehicle.fleetStartDate | date) : '-' }}</span></li>
                                <li><label>Fleet einde</label><span>{{ selectedVehicle.fleetEndDate ? (selectedVehicle.fleetEndDate | date) : '-' }}</span></li>
                                <li><label>Cataloguswaarde</label><span>{{ selectedVehicle.catalogValue | currency: 'EUR' }}</span></li>
                                <li><label>Eerste inschrijving</label><span>{{ selectedVehicle.firstRegistrationDate ? (selectedVehicle.firstRegistrationDate | date) : '-' }}</span></li>
                                <li><label>Hybride type</label><span>{{ selectedVehicle.hybridType || '-' }}</span></li>
                                <li><label>Hybride energie</label><span>{{ selectedVehicle.hybridEnergyCapacity || '-' }}</span></li>
                                <li><label>Historiek records</label><span>{{ selectedVehicle.history?.length || 0 }}</span></li>
                            </ul>

                            <h4 class="m-b-2">Bestuurder wijzigen</h4>

                            <div class="form-group m-b-2 fleet-field">
                                <label>Bestuurder</label>
                                <select [(ngModel)]="selectedDriverUuid">
                                    <option value="">-- Geen bestuurder --</option>
                                    <option *ngFor="let emp of employees" [value]="emp.uuid">{{ emp.firstName }} {{ emp.lastName }}</option>
                                </select>
                                <small *ngIf="selectedVehicle.driverOverridden" class="form-helptext">
                                    <i class="las la-pen"></i> Deze bestuurder is handmatig ingesteld en wordt niet overschreven bij een nieuwe CSV-import.
                                </small>
                            </div>

                            <h4 class="m-b-2">Notities</h4>

                            <div class="form-group m-b-2 fleet-field">
                                <label>Notities</label>
                                <textarea
                                    rows="4"
                                    [(ngModel)]="notes"
                                    class="resize-vertical"></textarea>
                            </div>

                            <button
                                class="button button--primary m-b-3"
                                [ngClass]="{ 'button--loading': saving }"
                                (click)="saveVehicleMeta()">
                                Opslaan
                            </button>

                            <h4 class="m-b-2">Documentextractie overzicht</h4>
                            <ul class="list__specs fleet-specs m-b-3" *ngFor="let doc of fleetDocumentRows">
                                <li>
                                    <label>{{ doc.label }}</label>
                                    <span>{{ doc.documentId ? 'Geüpload' : 'Ontbreekt' }}<span *ngIf="doc.extractionStatus"> ({{ doc.extractionStatus }})</span></span>
                                </li>
                                <li *ngFor="let item of getStructuredExtractedEntries(doc)">
                                    <label>{{ item.key }}</label>
                                    <span>{{ item.value }}</span>
                                </li>
                            </ul>
                        </ng-template>
                    </ng-container>

                    <ng-container [ngbNavItem]="'history'">
                        <a ngbNavLink>Historiek</a>
                        <ng-template ngbNavContent>
                            <table class="table-view table-view--small" *ngIf="selectedVehicle.history?.length > 0; else noHistory">
                                <tr>
                                    <th><button class="sort-button" (click)="toggleHistorySort('usageStartDate')">Periode {{ getHistorySortIndicator('usageStartDate') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('fleetStartDate')">Fleet periode {{ getHistorySortIndicator('fleetStartDate') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('employeeName')">Bestuurder {{ getHistorySortIndicator('employeeName') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('usageType')">Type gebruik {{ getHistorySortIndicator('usageType') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('estimatedFuelType')">Brandstof (geschat) {{ getHistorySortIndicator('estimatedFuelType') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('fuelType')">Brandstof {{ getHistorySortIndicator('fuelType') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('co2Emission')">CO2 {{ getHistorySortIndicator('co2Emission') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('co2Solidarity')">CO2-solid. {{ getHistorySortIndicator('co2Solidarity') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('catalogValue')">Catalogus {{ getHistorySortIndicator('catalogValue') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('firstRegistrationDate')">1e inschr. {{ getHistorySortIndicator('firstRegistrationDate') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('hybridType')">Hybride type {{ getHistorySortIndicator('hybridType') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('hybridEnergyCapacity')">Hybride energie {{ getHistorySortIndicator('hybridEnergyCapacity') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('co2Value1')">CO2 v1 {{ getHistorySortIndicator('co2Value1') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('co2Value2')">CO2 v2 {{ getHistorySortIndicator('co2Value2') }}</button></th>
                                    <th><button class="sort-button" (click)="toggleHistorySort('co2Value3')">CO2 v3 {{ getHistorySortIndicator('co2Value3') }}</button></th>
                                </tr>
                                <tr *ngFor="let item of getSortedHistory()">
                                    <td>{{ item.usageStartDate | date }} - {{ item.usageEndDate ? (item.usageEndDate | date) : '-' }}</td>
                                    <td>{{ item.fleetStartDate ? (item.fleetStartDate | date) : '-' }} - {{ item.fleetEndDate ? (item.fleetEndDate | date) : '-' }}</td>
                                    <td>{{ item.employeeName || '-' }} <span *ngIf="item.employeeNumber">({{ item.employeeNumber }})</span></td>
                                    <td>{{ item.usageType || '-' }}</td>
                                    <td>{{ item.estimatedFuelType || '-' }}</td>
                                    <td>{{ item.fuelType || '-' }}</td>
                                    <td>{{ item.co2Emission ?? '-' }}</td>
                                    <td>{{ item.co2Solidarity | currency: 'EUR' }}</td>
                                    <td>{{ item.catalogValue | currency: 'EUR' }}</td>
                                    <td>{{ item.firstRegistrationDate ? (item.firstRegistrationDate | date) : '-' }}</td>
                                    <td>{{ item.hybridType || '-' }}</td>
                                    <td>{{ item.hybridEnergyCapacity || '-' }}</td>
                                    <td>{{ item.co2Value1 ?? '-' }}</td>
                                    <td>{{ item.co2Value2 ?? '-' }}</td>
                                    <td>{{ item.co2Value3 ?? '-' }}</td>
                                </tr>
                            </table>
                        </ng-template>
                    </ng-container>

                    <ng-container [ngbNavItem]="'documents'">
                        <a ngbNavLink>Documenten</a>
                        <ng-template ngbNavContent>
                            <p class="sectiontitle sectiontitle--first">Standaard documenten</p>
                            <app-loading-message *ngIf="loadingFleetDocuments"></app-loading-message>

                            <table class="table-view table-view--small m-b-3" *ngIf="!loadingFleetDocuments">
                                <tr>
                                    <th>Document</th>
                                    <th>Status</th>
                                    <th>Extractie</th>
                                    <th>Acties</th>
                                </tr>
                                <tr *ngFor="let doc of fleetDocumentRows">
                                    <td>
                                        <button type="button" class="button button--link" (click)="openDocumentExtractionPopup(doc.type)">
                                            {{ doc.label }}
                                        </button>
                                    </td>
                                    <td>{{ doc.documentId ? 'Geüpload' : 'Ontbreekt' }}</td>
                                    <td>{{ doc.extractionStatus || '-' }}</td>
                                    <td>
                                        <button class="button button--small m-r-1" (click)="openStandardDocumentUpload(doc.type)">
                                            {{ doc.documentId ? 'Vervang' : 'Upload' }}
                                        </button>
                                        <button
                                            class="button button--small button--outline m-r-1"
                                            [disabled]="!doc.documentId || !doc.url"
                                            (click)="openStandardDocument(doc.type)">
                                            Bekijk
                                        </button>
                                        <button
                                            class="button button--small button--outline"
                                            [disabled]="!doc.documentId || doc.extracting"
                                            (click)="extractStandardDocument(doc.type)">
                                            {{ doc.extracting ? 'Extracting...' : 'AI extract' }}
                                        </button>
                                    </td>
                                </tr>
                            </table>

                            <div *ngFor="let doc of fleetDocumentRows">
                                <p
                                    *ngIf="getInsuranceExpiryWarning(doc)"
                                    class="m-b-2"
                                    [class.color--red]="isInsuranceExpired(doc)">
                                    {{ getInsuranceExpiryWarning(doc) }}
                                </p>
                            </div>

                            <div *ngFor="let doc of fleetDocumentRows" class="m-b-2" [hidden]="getExtractedEntries(doc).length === 0">
                                <p class="sectiontitle">{{ doc.label }} - Extractie</p>
                                <ul class="list__specs">
                                    <li *ngFor="let item of getExtractedEntries(doc)">
                                        <label>{{ item.key }}</label>
                                        <span>{{ item.value }}</span>
                                    </li>
                                </ul>
                            </div>

                            <p class="sectiontitle">Overige documenten</p>
                            <app-linked-invoices-to-object
                                [alreadyFetchedFiles]="false"
                                [showInvoices]="false"
                                [showFiles]="true"
                                [objectId]="selectedVehicle.uuid">
                            </app-linked-invoices-to-object>
                        </ng-template>
                    </ng-container>
                </nav>

                <div class="modal-body fleet-detail-modal__body">
                    <div [ngbNavOutlet]="nav"></div>

                    <ng-template #noHistory>
                        <small>Geen historiek beschikbaar.</small>
                    </ng-template>
                </div>
            </div>
        </ng-template>

        <ng-template #documentExtractModal let-close="close">
            <div class="modal-content">
                <div class="modal-content__header">
                    <h3 class="modal-content__title">Extractie - {{ selectedExtractionRow?.label }}</h3>
                    <button class="modal-content__close" type="button" aria-label="Close" (click)="close()"></button>
                </div>
                <div class="modal-content__body">
                    <ul class="list__specs" *ngIf="selectedExtractionRow as row">
                        <li>
                            <label>Status</label>
                            <span>{{ row.documentId ? 'Geüpload' : 'Ontbreekt' }}<span *ngIf="row.extractionStatus"> ({{ row.extractionStatus }})</span></span>
                        </li>
                        <li *ngFor="let item of getStructuredExtractedEntries(row, true)">
                            <label>{{ item.key }}</label>
                            <span>{{ item.value }}</span>
                        </li>
                    </ul>
                    <small *ngIf="selectedExtractionRow && getStructuredExtractedEntries(selectedExtractionRow, true).length === 0">
                        Geen geëxtraheerde gegevens beschikbaar voor dit document.
                    </small>
                </div>
            </div>
        </ng-template>
    </app-content>
</app-app-holder>
